// eslint-disable-next-line import/prefer-default-export
export const ROUTES = {
  PROGRAM_RECORDS: '/',
  VERIFIABLE_CREDENTIALS: '/verifiable-credentials',
  PROGRAM_RECORD_SHARED: '/shared/:programUUID',
  PROGRAM_RECORD_ITEM: '/:programUUID',
};
